// extracted by mini-css-extract-plugin
export var back = "ParagraphCaseStudy-module--back--36738";
export var buttonwrapper = "ParagraphCaseStudy-module--buttonwrapper--4c277";
export var details = "ParagraphCaseStudy-module--details--4ea84";
export var image = "ParagraphCaseStudy-module--image--83299";
export var navbuttons = "ParagraphCaseStudy-module--navbuttons--e9187";
export var next = "ParagraphCaseStudy-module--next--073b4";
export var paragraphcasestudycontainer = "ParagraphCaseStudy-module--paragraphcasestudycontainer--e3208";
export var signpostcardcarouselinner = "ParagraphCaseStudy-module--signpostcardcarouselinner--aafc0";
export var subheading = "ParagraphCaseStudy-module--subheading--36ac9";
export var swiper = "ParagraphCaseStudy-module--swiper--74f3c";
export var swiperwrapper = "ParagraphCaseStudy-module--swiperwrapper--28e89";
export var text = "ParagraphCaseStudy-module--text--63fc2";
export var title = "ParagraphCaseStudy-module--title--42a6e";